var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-evaluate"},[_c('back-nav',{attrs:{"to":'/lists/'+_vm.listId,"list-title":_vm.listTitle}}),_c('page-title',{attrs:{"title":'Rate ideas'}}),_c('ideas-to-evaluate',{attrs:{"listIds":[_vm.listId]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }